import { Modal } from 'bootstrap.native';

export class EarlyPaymentDiscount {
    /**
    * Dynamic handling of EarlyPaymentDiscount actions
    * @param {HTMLElement} element DOM element
    */
    constructor (element) {
        // Name, reference
        // element = this;
        this.element = element;

        // Elements
        this._refs = {
            buttons: element.querySelectorAll('input[type=radio]'),
            dialog: document.querySelector('.js-cart-dialog')
        };

        // Events
        if(this._refs.buttons !== null) {
            this._refs.buttons.forEach( button => {
                button.addEventListener('click', this._onSelectPaymentOption.bind(this))
            });
        }
    }

    /**
     * onSelect payment option
     * Toggle modal when Credit card payment is selected (EarlyPaymentDiscount only)
     * @param {Event} e - Event interface
     */
    _onSelectPaymentOption (e) {
        if(e.target.value === "ACH" || this._refs.dialog === null) return;

        const modal = this._refs.dialog.Modal || new Modal(this._refs.dialog);

        // Display modal
        this._onDisplayModal(this._refs.dialog, modal);

        // Hide modal event
        this._refs.dialog.addEventListener('hide.bs.modal', () => {this._onHideModal(this._refs.dialog, modal)}, false);
    }

    _onDisplayModal (e, modal) {
        modal.show();
        e.setAttribute('aria-hidden', false);
        e.setAttribute('tabindex', 0);
    }

    _onHideModal (e, modal) {
        modal.hide();
        e.setAttribute('aria-hidden', true);
        e.setAttribute('tabindex', -1);
        this.element.querySelector('input[value="ACH"]').click();
    }
}